import { render } from "./Notification.vue?vue&type=template&id=59c13d40"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "@/assets/scss/views/Notification.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script